var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/placeholder/components/placeholder_card.tsx";
import classNames from 'classnames';
import * as React from 'react';
import { randomIntFromInterval, generateText } from '../utils';

/** Fake link preview to display while data is loading. */
const PlaceholderCard = () => /*#__PURE__*/React.createElement("div", {
  className: classNames('status-card', {
    'animate-pulse': true
  }),
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 8,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "w-2/5 bg-slate-200 rounded-l",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 12,
    columnNumber: 5
  }
}, "\xA0"), /*#__PURE__*/React.createElement("div", {
  className: "w-3/5 p-4 flex flex-col justify-between text-slate-200 break-words",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 14,
    columnNumber: 5
  }
}, /*#__PURE__*/React.createElement("p", {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 15,
    columnNumber: 7
  }
}, generateText(randomIntFromInterval(5, 25))), /*#__PURE__*/React.createElement("p", {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 16,
    columnNumber: 7
  }
}, generateText(randomIntFromInterval(5, 75))), /*#__PURE__*/React.createElement("p", {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 17,
    columnNumber: 7
  }
}, generateText(randomIntFromInterval(5, 15)))));
export default /*#__PURE__*/React.memo(PlaceholderCard);